module.exports = "<div class=widget-placeholder> No widgets available for the selected panel. </div> ";